/* Free-gift checkout guard, UX half.
 *
 * When the cart holds nothing but `free-gift` products, the Rebuy Smart Cart's
 * checkout button goes inert and a one-line reason sits above it. This is the
 * explanation, not the enforcement: the cart validation function in
 * shopify-cart-rules/ blocks every checkout path server-side. Spec:
 * ~/Downloads/rebuy-free-gift-checkout-block.md (2026-09-08).
 *
 * Verified against the live drawer 2026-09-08: the drawer is `.rebuy-cart`,
 * the button `.rebuy-cart__checkout-button`, there is no
 * `.rebuy-cart__checkout-buttons` wrapper, and each Smart Cart item carries
 * its product's tags as a comma-separated STRING on `item.product.tags`.
 */
(function () {
  'use strict';
  var GIFT_TAG = 'free-gift';
  var MESSAGE = 'Your cart only has free gifts. Add a product to check out.';
  var NOTICE_ID = 'free-only-notice';

  var css = '' +
    '.rebuy-cart .free-only-notice{margin:0 0 .75rem;font-size:.875rem;line-height:1.4;color:#57201F;}' +
    '.rebuy-cart .free-only-notice:focus{outline:2px solid #DC5E35;outline-offset:2px;}' +
    '.rebuy-cart.free-only .rebuy-cart__checkout-button{opacity:.5;cursor:not-allowed;}' +
    '.rebuy-cart.free-only .rebuy-cart__express-checkout,' +
    '.rebuy-cart.free-only .additional-checkout-buttons,' +
    '.rebuy-cart.free-only [data-rebuy-express-checkout]{display:none;}';
  var style = document.createElement('style');
  style.setAttribute('data-free-gift-guard', '');
  style.textContent = css;
  document.head.appendChild(style);

  function tagsOf(item) {
    var raw = (item && item.product && item.product.tags) || item.product_tags || item.tags || [];
    if (typeof raw === 'string') raw = raw.split(',');
    return raw.map(function (t) { return String(t).trim().toLowerCase(); });
  }
  function isGift(item) { return tagsOf(item).indexOf(GIFT_TAG) !== -1; }

  function ensureNotice(container, button) {
    var notice = container.querySelector('.free-only-notice');
    if (!notice) {
      notice = document.createElement('p');
      notice.className = 'free-only-notice';
      notice.id = NOTICE_ID;
      notice.setAttribute('role', 'status');
      notice.setAttribute('aria-live', 'polite');
      notice.setAttribute('tabindex', '-1');
      notice.hidden = true;
    }
    // Rebuy re-renders the drawer, so keep the notice directly above the button.
    if (button && notice.nextElementSibling !== button) button.parentNode.insertBefore(notice, button);
    return notice;
  }

  var lastBlocked = null;
  function guard() {
    var sc = window.Rebuy && window.Rebuy.SmartCart;
    var cart = sc && sc.cart;
    var container = document.querySelector('.rebuy-cart');
    if (!cart || !cart.items || !container) return;

    var blocked = cart.items.length > 0 && cart.items.every(isGift);
    container.classList.toggle('free-only', blocked);

    var buttons = container.querySelectorAll('.rebuy-cart__checkout-button');
    var notice = ensureNotice(container, buttons[0] || null);
    if (blocked !== lastBlocked) { notice.textContent = blocked ? MESSAGE : ''; lastBlocked = blocked; }
    notice.hidden = !blocked;

    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      btn.setAttribute('aria-disabled', String(blocked));
      if (blocked) btn.setAttribute('aria-describedby', NOTICE_ID);
      else btn.removeAttribute('aria-describedby');
    }
  }

  function intercept(event) {
    var btn = event.target && event.target.closest && event.target.closest('.rebuy-cart__checkout-button');
    if (btn && btn.getAttribute('aria-disabled') === 'true') {
      event.preventDefault();
      event.stopImmediatePropagation();
      var notice = document.getElementById(NOTICE_ID);
      if (notice) notice.focus();
    }
  }

  ['rebuy:smartcart.ready', 'rebuy:smartcart.show', 'rebuy:cart.change', 'rebuy:cart.add', 'rebuy:cart.remove', 'cart:item-added', 'cart:updated']
    .forEach(function (evt) { document.addEventListener(evt, guard); });
  document.addEventListener('click', intercept, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') intercept(e); }, true);

  // The drawer is re-rendered by Rebuy on every change; re-check after each
  // render so the notice and the button state survive it.
  var pending = null;
  function schedule() { if (pending) return; pending = window.setTimeout(function () { pending = null; guard(); }, 80); }
  function observe() {
    var container = document.querySelector('.rebuy-cart');
    if (!container) { window.setTimeout(observe, 500); return; }
    new MutationObserver(schedule).observe(container, { childList: true, subtree: true });
    guard();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observe);
  else observe();

  window.SubtlFreeGiftGuard = { check: guard, isGift: isGift };
})();
